// @flow
import Team from 'components/hub/Team';
import { connect } from 'react-redux';

import type { StateType } from 'types/Actions';
import type { StateProps } from 'components/hub/Team';

export default connect(
  (state: StateType): StateProps => ({
    categoriesArticle: state.newsletterState.categoriesArticle,
    equipes_une: state.settingsState.equipes_une,
    equipes_une_titre: state.settingsState.equipes_une_titre,
    equipes_une_description: state.settingsState.equipes_une_description,
    equipes_une_cta: state.settingsState.equipes_une_cta,
    equipes_une_lien: state.settingsState.equipes_une_lien,
  }),
)(Team);
